import { Text } from "@ui-kitten/components";
import Dialog from "components/Dialog";
import EventNoticeIcon from "components/EventNoticeIcon";
import RenderHtmlComponent from "components/RenderHtml";
import { EventNoticeDetails } from "features/types";
import i18n from "plugins/localization";
import React from "react";
import { View, ScrollView } from "react-native";

interface ImportantMessageDialogProps {
  notices: EventNoticeDetails[];
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
}
const ImportantMessageDialog: React.FC<ImportantMessageDialogProps> = ({
  notices,
  visible,
  setVisible,
}) => {
  return (
    <Dialog
      visible={visible}
      setVisible={setVisible}
      onOk={() => setVisible(false)}
      okText="OK"
    >
      <Text category="h6" style={{ marginBottom: 15 }}>
        {i18n.t("screens.Reserve.importantMessages")}
      </Text>
      <ScrollView
        style={{ maxHeight: 200 }}
        showsVerticalScrollIndicator={false}
      >
        {notices.map((notice) => (
          <View key={notice.id} style={{ marginBottom: 15 }}>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <EventNoticeIcon type={notice.type} size={24} />
              <Text style={{ marginLeft: 5 }}>{notice.tag}</Text>
            </View>
            <RenderHtmlComponent source={notice.description} />
          </View>
        ))}
      </ScrollView>
    </Dialog>
  );
};

export default ImportantMessageDialog;
